// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"b06d9d6b","container":"a2f86fc9"};